import {
  DialogDescription,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogClose,
  DialogTitle,
  Button,
  Dialog,
  toast,
} from '@ui/components';
import { useOnboardingImportedEmployees } from '@pages/onboarding/hooks';
import { ErrorDetailsDtoErrorCodeEnum } from '@interfaces/models';
import { useTranslation } from 'react-i18next';

export const RemoveEmployeeDialog = ({
  employeeId,
  isOpen,
  onClose,
}: {
  onClose: ({ hasBeenModified }?: { hasBeenModified: boolean }) => void;
  employeeId: string;
  isOpen: boolean;
}) => {
  const { t } = useTranslation();

  const { removeEmployee, isRemoveEmployeePending } = useOnboardingImportedEmployees({
    onRemoveEmployeeSuccess: () => {
      onClose({
        hasBeenModified: true,
      });

      toast.success(t('ONBOARDING.IMPORT_EMPLOYEES.EMPLOYEE_REMOVED_SUCCESSFULLY'));
    },
    onRemoveEmployeeError: (error: ErrorDetailsDtoErrorCodeEnum) => {
      toast.error(t(`API_ERRORS.${error || 'DEFAULT'}`));
    },
  });

  const handleRemoveEmployee = () => {
    removeEmployee(employeeId);
  };

  return (
    <Dialog onOpenChange={() => onClose()} open={isOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('ONBOARDING.IMPORT_EMPLOYEES.REMOVE_EMPLOYEE_DIALOG_TITLE')}</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          {t('ONBOARDING.IMPORT_EMPLOYEES.REMOVE_EMPLOYEE_DIALOG_DESCRIPTION')}
        </DialogDescription>
        <DialogFooter>
          <DialogClose asChild>
            <Button disabled={isRemoveEmployeePending} variant="tertiary" size="large" wide>
              {t('ONBOARDING.IMPORT_EMPLOYEES.REMOVE_EMPLOYEE_DIALOG_CANCEL')}
            </Button>
          </DialogClose>
          <Button
            isLoading={isRemoveEmployeePending}
            disabled={isRemoveEmployeePending}
            onClick={handleRemoveEmployee}
            size="large"
            wide
          >
            {t('ONBOARDING.IMPORT_EMPLOYEES.REMOVE_EMPLOYEE_DIALOG_DELETE')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
